import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

const DEFAULT_GA_MEASUREMENT_ID = 'G-MR5SDNKF45';
const booleanFlag = z
  .union([z.boolean(), z.enum(['true', 'false'])])
  .transform((value) => value === true || value === 'true');

export const keys = () =>
  createEnv({
    client: {
      // Google Analytics
      NEXT_PUBLIC_ANALYTICS_GA_MEASUREMENT_ID: z.string().optional(),
      NEXT_PUBLIC_ANALYTICS_GA_DISABLE_LOCALHOST_TRACKING: booleanFlag,
      NEXT_PUBLIC_ANALYTICS_GA_DISABLE_PAGE_VIEWS_TRACKING: booleanFlag,

      // PostHog
      NEXT_PUBLIC_ANALYTICS_POSTHOG_KEY: z.string().optional(),
      NEXT_PUBLIC_ANALYTICS_POSTHOG_HOST: z.string().optional(),

      // Umami
      NEXT_PUBLIC_ANALYTICS_UMAMI_HOST: z.string().optional(),
      NEXT_PUBLIC_ANALYTICS_UMAMI_WEBSITE_ID: z.string().optional(),
      NEXT_PUBLIC_ANALYTICS_UMAMI_DISABLE_LOCALHOST_TRACKING: booleanFlag
    },
    runtimeEnv: {
      // Google Analytics
      NEXT_PUBLIC_ANALYTICS_GA_MEASUREMENT_ID:
        process.env.NEXT_PUBLIC_ANALYTICS_GA_MEASUREMENT_ID ||
        DEFAULT_GA_MEASUREMENT_ID,
      NEXT_PUBLIC_ANALYTICS_GA_DISABLE_LOCALHOST_TRACKING:
        process.env.NEXT_PUBLIC_ANALYTICS_GA_DISABLE_LOCALHOST_TRACKING ??
        'true',
      NEXT_PUBLIC_ANALYTICS_GA_DISABLE_PAGE_VIEWS_TRACKING:
        process.env.NEXT_PUBLIC_ANALYTICS_GA_DISABLE_PAGE_VIEWS_TRACKING ??
        'false',

      // PostHog
      NEXT_PUBLIC_ANALYTICS_POSTHOG_KEY:
        process.env.NEXT_PUBLIC_ANALYTICS_POSTHOG_KEY,
      NEXT_PUBLIC_ANALYTICS_POSTHOG_HOST:
        process.env.NEXT_PUBLIC_ANALYTICS_POSTHOG_HOST,

      // Umami
      NEXT_PUBLIC_ANALYTICS_UMAMI_HOST:
        process.env.NEXT_PUBLIC_ANALYTICS_UMAMI_HOST,
      NEXT_PUBLIC_ANALYTICS_UMAMI_WEBSITE_ID:
        process.env.NEXT_PUBLIC_ANALYTICS_UMAMI_WEBSITE_ID,
      NEXT_PUBLIC_ANALYTICS_UMAMI_DISABLE_LOCALHOST_TRACKING:
        process.env.NEXT_PUBLIC_ANALYTICS_UMAMI_DISABLE_LOCALHOST_TRACKING ??
        'false'
    }
  });
